import { css } from '@/styled-system/css';

export const rowStyles = css.raw({
  width: '100%',
  margin: '{spacing.200} 0 {spacing.100}',
  display: 'flex',
  justifyContent: 'space-between',
});

export const sharedPropertyContainerStyles = css.raw({
  width: '100%',
  minHeight: '30px',
  marginBottom: '400',
  display: 'flex',
  justifyContent: 'center',
});
